module.exports = __webpack_public_path__ + "img/personal_watch_active.1c05b2e3.png";